import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, DOCUMENT, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { BaseComponent } from '../../../base/base.component';
import { InstagramData } from '../../../../shared/public-api';

@Component({
  selector: 'admin-instagram',
  templateUrl: './instagram.component.html',
  styleUrls: ['./instagram.component.scss'],
  imports: [CommonModule],
})
export class InstagramComponent extends BaseComponent<InstagramData> implements OnInit {
  postId = '';
  permalink: string;
  platformId: Object;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {
    super();
    this.platformId = platformId;
  }

  ngOnInit(): void {
    this.postId = this.data.postId;
    this.permalink = `https://www.instagram.com/p/${this.postId}/?utm_source=ig_embed`;
    if (isPlatformBrowser(this.platformId)) {
      this.loadScript();
    }
  }

  private loadScript(): void {
    let node = this.document.createElement('script');
    node.src = 'https://www.instagram.com/embed.js';
    node.type = 'text/javascript';
    node.async = true;
    this.document.getElementsByTagName('head')[0].appendChild(node);
  }
}
